import {sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';

import {
    setPasswordFx,
    error$,
    success$,
    Gate,
    resetPasswordRequestFx,
    resetPasswordFx,
    resetPasswordByAdminRequestFx,
    changePasswordFx,
    createPasswordRequestFx,
    resetPasswordByAdminClicked,
    expired$,
    setExpired,
} from './index';

error$
    .on(setPasswordFx.failData, (_, error) => {
        if ((error as RestError).status === 405) {
            toast.error(i18next.t('pages.password.set.expired.title'));
            setExpired(true);
        } else showRestError(error as RestError);
    })
    .reset([setPasswordFx.done, Gate.close]);
success$
    .on([setPasswordFx.done, resetPasswordFx.done, resetPasswordRequestFx.doneData], () => true)
    .reset([setPasswordFx.pending, Gate.close]);
expired$.on(setExpired, (_, state) => state).reset([Gate.close]);

sample({
    clock: resetPasswordByAdminClicked,
    target: resetPasswordByAdminRequestFx,
});

[
    resetPasswordFx,
    resetPasswordRequestFx,
    resetPasswordByAdminRequestFx,
    createPasswordRequestFx,
    changePasswordFx,
].forEach((fx) => fx.failData.watch((err) => showRestError(err as RestError)));
setPasswordFx.doneData.watch(() => toast.success(i18next.t('pages.password.set.messages.success')));
resetPasswordFx.doneData.watch(() =>
    toast.success(i18next.t('pages.password.reset.messages.success')),
);
resetPasswordByAdminRequestFx.doneData.watch(() =>
    toast.success(i18next.t('pages.password.reset.messages.resetByAdmin')),
);
changePasswordFx.doneData.watch(() =>
    toast.success(i18next.t('pages.password.change.messages.success')),
);
